/** @format */

import React, { Component } from "react";
import axios from "axios";
import Cookies from "js-cookie";import { notifyErrorMessage } from "../App";
;

export const IMG_DIR = 'https://nekooyad.com/proc/public/Images/'
export const SOUND_DIR = 'https://nekooyad.com/proc/public/Sounds/'
export const WEB_URL = 'https://nekooyad.com'

class JWT extends Component {
  constructor(props) {
    super(props);
    axios.defaults.baseURL = "https://nekooyad.com/proc/api/";
    axios.defaults.timeout = 160000;
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers['Access-Control-Allow-Methods'] = '*';
    this.setInterceptors();
  }
  setHeaderForAxios = async (token) => {
    axios.interceptors.request.use(
      (config) => {
        config.headers.Authorization = "Bearer " + token; //localStorage.getItem("token");
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  };

  setInterceptors = () => {
    axios.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("token");
        config.headers.Authorization = "Bearer " + token; //localStorage.getItem("token");
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (err) => {
        return new Promise(() => {
          if (err) {
            if (405 === err?.response?.status) {
              throw err.response?.data;
            } else if (400 === err?.response?.status) {
              throw err.response?.data;
            } else if (404 === err?.response?.status) {

              // Router.push("/404");

            } else if (err?.response?.status === 401) {
              const errorMessage = "اطلاعات کاربری صحیح نیست";
              // Router.push("/login?type='toast'");
              notifyErrorMessage(errorMessage)
              throw errorMessage;
            }
            //  else if (
            //   err?.message &&
            //   JSON.parse(err)?.message === "Network Error"
            // ) {
            //   throw {
            //     status: 600,
            //     data: {
            //       user_message: "اینترنت قطع است ، لطفا اینترنت خود را چک کنید",
            //     },
            //   };
            // }
            else {
              const errorMessage = "خطایی رخ داده است";
              throw err.response;
            }
          } else if (axios.isCancel(err)) {
            // request canceled
            throw err;
          }
        });
      }
    );
  };
  getDataFromServer = async (api_route, params = {}) => {
    try {
      const res = await axios
        .get(api_route, params);
      return res;
    } catch (err) {
      throw err;
    }
  };

  PostDataToServer = async (api_route, data = {}, header = {}) => {
    try {
      const res = await axios
        .post(api_route, data, header);
      return res
    } catch (err) {
      throw err;
    }
  };
  EditDataToServer = async (api_route, data = {}, header = {}) => {
    try {
      const res = await axios
        .put(api_route, data, header);
      return res.data;
    } catch (err) {
      throw err;
    }
  };
  DeleteFromServer = async (api_route, data = {}, header = {}) => {
    console.log("data", data)
    // return axios
    //   .delete(api_route, { data: { id: 42 } })
    //   .then((res) => {
    //     return res.data;
    //   })
    //   .catch((err) => {
    //     throw err;
    //   });
    return axios.delete('/Address', {
      data: { foo: 'bar' }
    })
    // const res = await axios.delete('/Address', { data:data  })
    // console.log(res)
  };
}

const sia = new JWT();
export default sia;
